import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { purchasePackage } from '../../services/userpackage';
import verify from "../../assets/images/verify.png";

function PaymentSuccess() {
  const params = useParams();
  const packageId = params.packageId;
  const couponId = params.couponId;
  // Keys holding the in-progress selection. Cleared after the purchase is
  // recorded. Deliberately NOT localStorage.clear(): that also wipes token /
  // jwt / userId, which logged the user out BEFORE this component could call
  // the authenticated purchase endpoint - so the purchase was never recorded,
  // the redirect below never ran, and the user was stranded here and signed out.
  const SELECTION_KEYS = [
    'selectedPackageId', 'selectedPackageName', 'selectedThemeId',
    'themeName', 'description',
  ];

  // Set when the server could not confirm the payment after a few tries.
  const [notConfirmed, setNotConfirmed] = useState(false);

  useEffect(() => {
    packagePurchase(1);
  }, []);

  // Stripe's confirmation can reach the server a few seconds after the buyer is sent back here,
  // so a refusal is retried before giving up. The server also grants the package from that
  // confirmation, so it still arrives if this page gives up or is closed.
  const packagePurchase = async (attempt) => {
    let granted = false;
    try {
      const res = await purchasePackage(packageId, couponId);
      granted = !!(res && res.data && res.data.data);
    } catch (error) {
      console.error('Package purchase not confirmed yet (attempt ' + attempt + ')', error);
    }
    if (!granted && attempt < 4) {
      window.setTimeout(function () { packagePurchase(attempt + 1); }, 3000);
      return;
    }
    SELECTION_KEYS.forEach((key) => localStorage.removeItem(key));
    if (granted) {
      window.setTimeout(function () {
        window.location.replace("/packages");
      }, 3000);
    } else {
      setNotConfirmed(true);
    }
  };

  return (
    <>
          <div className="app-main flex-column flex-row-fluid " id="kt_app_main">
            <div className="d-flex flex-column flex-column-fluid">
              <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">

                <div id="kt_app_toolbar_container" className="app-container  container-xxl d-flex flex-stack ">



                  <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3 ">

                  </div>

                </div>
              </div>

              <div id="kt_app_content" className="app-content  flex-column-fluid " >


                <div id="kt_app_content_container" className="app-container  container-xxl ">
                  <div className="row g-5 g-xl-10 mb-80">
                    <div className="col">

                      <div className="card card-flush h-md-100">
                        <div className="card-body pt-7">
                          <h3 className="card-title align-items-start flex-column text-center">
                            <img src={verify} className="h-60px h-lg-75px" />
                            <h1 className="card-label fw-bold text-gray-800 fs-35 mt-10">Thank You</h1>
                            <h1 className="card-label fw-bold text-gray-800">for Purchasing Package.</h1>
                            {notConfirmed ?
                              <p className="fs-5 text-gray-700 mt-6">We have not been able to confirm your payment yet.
                                Your package will be added as soon as it clears. If it has not appeared under Packages
                                within a few minutes, please contact support@vertivio.com.</p>
                            : <></>}
                          </h3>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            </div>
    </>
  );
}

export default PaymentSuccess;